import React from 'react';

const Review = (props) => {
    const { name, review, rating } = props.revieew;
    return (
        <div className='car'>
            <div className='car-info'>
                <p className='car-name'>{name}</p>
                <p style={{ fontFamily: 'Poppins', color: 'rgb(53, 50, 50)' }}>{review}</p>
                <div className='d-flex justify-content-center align-items-center'>
                    <div style={{ marginRight: '50px', color: 'palevioletred' }}>
                        {
                            rating == 0 && <div>
                                <i class="far fa-star"></i><i class="far fa-star"></i><i class="far fa-star"></i><i class="far fa-star"></i><i class="far fa-star"></i>
                            </div>
                        }
                        {
                            rating == 1 && <div>
                                <i class="fas fa-star"></i><i class="far fa-star"></i><i class="far fa-star"></i><i class="far fa-star"></i><i class="far fa-star"></i>
                            </div>
                        }
                        {
                            rating == 2 && <div>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="far fa-star"></i>
                                <i class="far fa-star"></i>
                                <i class="far fa-star"></i>
                            </div>
                        }
                        {
                            rating == 3 && <div>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="far fa-star"></i>
                                <i class="far fa-star"></i>
                            </div>
                        }
                        {
                            rating == 4 && <div>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="far fa-star"></i>
                            </div>
                        }
                        {
                            rating == 5 && <div>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                            </div>
                        }

                    </div>
                    <div>
                        <h4 className='car-price'>{rating}/5</h4>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Review;